<template>
  <div>
    <div class="upload-demo" v-if="!ques.isSelectFile">
      <div class="el-upload el-upload--text" @click="handelClick">
        <div class="el-upload-dragger">
          <div class="upload-content">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              <span>仅支持单文件</span>
              <em href="javascript:;" class="file">
                点击上传
              </em>
            </div>
          </div>
        </div>
      </div>
      <div class="el-upload__tip" slot="tip">
        可上传gif, png, jpg, jpeg, bmp, doc, docx, pdf, xls, xlsx, ppt, pptx, txt, zip, gzip, rar文件，且不超过50M
      </div>
    </div>
    <div v-else class="upload-res">
      <img v-if="imgSrc" class="thumbnail" :src="imgSrc" alt />
      <div class="upload-progress">
        <div class="el-upload__tip upload-filename">
          <span>{{ ques.fileNameSrc }}</span>
          <span
            v-if="ques.isFinish"
            class="el-icon-close clear-upload"
            @click="handleClearFile(ques)"
          ></span>
        </div>
        <el-progress
          v-if="ques.isSelectFile"
          :stroke-width="8"
          :percentage="ques.uploadPercentage"
        ></el-progress>
      </div>
    </div>
    <input
      type="file"
      ref="file"
      name="file"
      class="upload-input"
      @change="handleFileChange"
    />
  </div>
</template>
<script>
import http from '../utils/upload'
// import http from '../utils/http'
import { getTimestamp } from '../utils/utils'
import compressionImg from '@/utils/compressionImg'
import WosSys from '@/utils/wos-js-sdk-v2_v0'
export default {
  data() {
    return {
      interface: {
        getInfo: '/upload/info',
        getToken: '/upload/get_token'
      },
      uploadType: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'bmp',
        'doc',
        'docx',
        'pdf',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'txt',
        'zip',
        'gzip',
        'rar'
      ],
      imgType: ['gif', 'png', 'jpg', 'jpeg', 'bmp'],
      imgSrc: ''
    }
  },
  props: ['ques'],
  methods: {
    handelClick() {
      this.$refs.file.click()
    },
    async handleFileChange(ev) {
      let files = ev.target.files || []
      let file = files[0]
      if (!file) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空'
        })
        return
      }
      if (files.length > 0) {
        let filename = file.name
        let index = filename.lastIndexOf('.')
        let ext = filename.slice(index + 1)
        let _filename = filename.slice(0, index)
        if (ext) {
          ext = ext.toLowerCase()
        }
        if (!!ext && !this.uploadType.includes(ext)) {
          this.$message({
            type: 'error',
            message: '请上传规定格式的文件'
          })
        } else if (file.size / (1024 * 1024) > 50) {
          this.$message({
            type: 'error',
            message: '上传文件不能超过50M'
          })
        } else {
          _filename = _filename + '_' + getTimestamp() + '.' + ext
          if (this.imgType.indexOf(ext) > -1) {
            file = await compressionImg(file, 5 * 1024 * 1024)
          }
          this.uploadFile(this.ques, _filename, file)
          this.showImg(file, ext)
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请选择文件'
        })
      }
    },
    async uploadFile(ques, filename, file) {
      try {
        let res = await http.get(this.interface.getInfo)
        let { code, data } = res.data
        if (code == 1) {
          const { appkey, bucket, url } = JSON.parse(data)
          let res1 = await http.get(this.interface.getToken, {
            bucket: bucket,
            filename: filename
          })
          const resData = res1.data
          if (resData && resData.code == 1) {
            filename = resData.data.filename
            // file.name = filename
            const cos = new WosSys({
              appid: appkey,
              bucket,
              wosurl: 'https://' + url,
              getAppSign: callback => {
                callback(encodeURIComponent(resData.data.token))
              }
            })
            cos.uploadFile(
              success => {
                const {
                  data: { url }
                } = JSON.parse(success)
                this.$emit('fileChange', ques, {
                  fileNameSrc: filename,
                  fileNameDst: url,
                  isFinish: true,
                  isSelectFile: true,
                  uploadPercentage: 100
                })
              },
              () => {
                this.$emit('fileChange', ques, {
                  isSelectFile: false
                })
              },
              propgress => {
                let persentage = parseInt(propgress * 100)
                this.$emit('fileChange', ques, {
                  uploadPercentage: persentage,
                  isSelectFile: true
                })
              },
              bucket,
              filename,
              file,
              0
            )
          } else {
            this.$message({
              type: 'error',
              message: '失败！错误原因：' + resData.message
            })
          }
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: '失败！错误原因：' + err.toString()
        })
      }
    },

    handleClearFile(ques) {
      this.imgSrc = ''
      this.$emit('fileChange', ques, {
        uploadPercentage: 0,
        fileNameSrc: '',
        isSelectFile: false,
        isFinish: false
      })
    },
    showImg(file, ext) {
      if (this.imgType.indexOf(ext) > -1 && window.FileReader) {
        var fr = new FileReader()
        fr.onloadend = e => {
          this.imgSrc = e.target.result
        }
        fr.readAsDataURL(file)
      } else {
        this.imgSrc = ''
      }
    }
  }
}
</script>

<style lang="scss">
.upload-input {
  display: none;
}
.upload-demo {
  .el-upload--text {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
      .upload-content {
        width: 200px;
        margin: 0 auto;
      }
    }
  }
  .clear-upload {
    margin-left: 20px;
    &:hover {
      cursor: pointer;
    }
  }
}
.el-upload__text {
  & > span {
    vertical-align: middle;
  }
}
.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  font-size: 14px;
  vertical-align: middle;
  &:hover {
    font-weight: bold;
  }
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.upload-res {
  display: flex;
  .thumbnail {
    max-width: 36px;
    max-height: 36px;
    margin-right: 10px;
  }
  .upload-filename {
    margin-top: 0;
  }
  .upload-progress {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue